export default {
  list (state) {
    return state.list
  },
  listLoading (state) {
    return state.listLoading
  }
}
